/*
 * This file is loaded first in the website
 * and should only be used for critical JS code.
 *
 * All other code should exist within the React bundle (main.bundle.js).
 *
 * TABLE OF CONTENTS
 * - Region Detection
 * - PolyFills
 * - Browser Language Detection
 *
 */

/********************************** DETERMINE REGION OF USER */

window.keeperPreload = window.keeperPreload || {};

window.isUserFromUS = null;
window.hasGTMLoaded = null;
window.hasGALoaded = null;

window.keeperPreload.apiEndpoint = window.location.origin.replace('www.', '');
window.keeperPreload.downloadEndpoint = window.location.origin.replace('www.', 'download.');

window.keeperPreload.dataRegionApiEndpoint = () => {
    let endpoint = window.location.origin.replace('www.', '');
    const data_region = window.keeper.getParams()['data_region'] || '';

    // Routing overrides for this page only
    // JP Data Center Routing
    if (data_region === 'jp') {
        endpoint = endpoint.replace('.eu', '.com');
        endpoint = endpoint.replace('.com.au', '.com');
        endpoint = endpoint.replace('.com', '.jp');
    }

    // CA Data Center Routing
    if (data_region === 'ca') {
        endpoint = endpoint.replace('.eu', '.com');
        endpoint = endpoint.replace('.com.au', '.com');
        endpoint = endpoint.replace('.com', '.ca');
    }

    // EU Data Center Routing
    if (data_region === 'eu') {
        endpoint = endpoint.replace('.eu', '.com');
        endpoint = endpoint.replace('.com.au', '.com');
        endpoint = endpoint.replace('.com', '.eu');
    }

    // AU Data Center Routing
    if (data_region === 'au') {
        endpoint = endpoint.replace('.eu', '.com');
        endpoint = endpoint.replace('.com.au', '.com');
        endpoint = endpoint.replace('.com', '.com.au');
    }
    return endpoint;
};

window.keeperPreload.regionalApiEndpoint = dataRegionOverride => {
    let endpoint = window.location.origin.replace('www.', '');
    let params = new URLSearchParams(document.location.search);
    const region = (
        dataRegionOverride ||
        params.get('data_region') ||
        window.localStorage.getItem('original_keeper_region') ||
        'us'
    ).toLowerCase();

    // EU Data Center Routing
    if (region === 'eu') {
        endpoint = endpoint.replace('.com', '.eu');
    }
    // JP Data Center Routing
    if (region === 'jp') {
        endpoint = endpoint.replace('.com', '.jp');
    }
    // CA Data Center Routing
    if (region === 'ca') {
        endpoint = endpoint.replace('.com', '.ca');
    }
    // AU Data Center Routing
    if (region === 'au') {
        endpoint = endpoint.replace('.eu', '.com');
        endpoint = endpoint.replace('.com', '.com.au');
    }
    return endpoint;
};

window.whatOSPreload = () => {
    const ua = (window.navigator && window.navigator.userAgent) || '';
    if (ua.indexOf('BlackBerry') !== -1 || ua.indexOf('BB10') !== -1) {
        return 'BlackBerry';
    }
    if (
        ua.indexOf('Silk') !== -1 ||
        (ua.indexOf('Firefox') === -1 && ua.indexOf('Fire') !== -1) ||
        ua.indexOf('KFTT') !== -1 ||
        ua.indexOf('KFOT') !== -1 ||
        ua.indexOf('KFJWA') !== -1 ||
        ua.indexOf('KFJWI') !== -1 ||
        ua.indexOf('KFSOWI') !== -1 ||
        ua.indexOf('KFTHWA') !== -1 ||
        ua.indexOf('KFTHWI') !== -1 ||
        ua.indexOf('KFAPWA') !== -1 ||
        ua.indexOf('KFAPWI') !== -1
    ) {
        return 'Kindle';
    }
    if (ua.indexOf('Windows Phone') !== -1) {
        return 'WinPhone';
    }
    if (ua.indexOf('iPhone') !== -1) {
        return 'iPhone';
    }
    if (ua.indexOf('iPad') !== -1) {
        return 'iPad';
    }
    if (ua.indexOf('Android') !== -1) {
        return 'Android';
    }
    // Look for older OS versions
    if (ua.indexOf('Mac OS X') !== -1) {
        if (ua.indexOf('X 10.7') !== -1 || ua.indexOf('X 10_7') !== -1) {
            return 'oldmac';
        } else if (ua.indexOf('X 10.6') !== -1 || ua.indexOf('X 10_6') !== -1) {
            return 'oldmac';
        } else if (ua.indexOf('X 10.5') !== -1 || ua.indexOf('X 10_5') !== -1) {
            return 'oldmac';
        }
    }
    if (ua.indexOf('Macintosh') !== -1) {
        return 'mac';
    }
    if (ua.indexOf('Windows') !== -1) {
        return 'win';
    }
    if (ua.indexOf('Linux') !== -1) {
        return 'nix';
    }
    return 'NA';
};

// Add OS class to html element
(() => {
    document.getElementsByTagName('html')[0].classList.add(whatOSPreload());
})();

window.whatBrowserPreload = () => {
    const ua = (window.navigator && window.navigator.userAgent) || '';

    if ((window.navigator.brave && window.navigator.brave.isBrave()) || false) {
        return 'brave';
    }
    if (ua.indexOf('Edg/') !== -1) {
        return 'chromium-edge';
    }
    if (ua.indexOf('Edge') !== -1) {
        return 'edge';
    }
    if (ua.indexOf('Opera') !== -1 || ua.indexOf('OPR') !== -1) {
        return 'opera';
    }
    if (ua.indexOf('Chrome') !== -1) {
        return 'chrome';
    }
    if (ua.indexOf('Safari') !== -1) {
        return 'safari';
    }
    if (ua.indexOf('Firefox') !== -1) {
        return 'firefox';
    }
    if (ua.indexOf('MSIE') !== -1 || typeof Windows !== 'undefined') {
        return 'ie';
    }
    // IE 11 of course is completely different
    if (ua.indexOf('Trident') !== -1) {
        return 'ie';
    }
    return 'NA';
};

// Add browser class to html element
(() => {
    document.getElementsByTagName('html')[0].classList.add(whatBrowserPreload());
})();

// Show or hide promo banner
(() => {
    const localStorageHeadPromo = window.localStorage.getItem('headPromo');
    const shouldShowPromo = localStorageHeadPromo === 'true' || localStorageHeadPromo === null;
    document.documentElement.classList.toggle('headPromo', shouldShowPromo);
})();

window.setidMeBannerVetsFirstRespondersClass = startDateString => {
    var today = Date.now();
    var startDate = new Date(startDateString).getTime();

    if (today >= startDate) {
        document.getElementsByTagName('html')[0].classList.add('idMeBannerVetsFirstResponders');
    }
};

setidMeBannerVetsFirstRespondersClass('12 Sep 2021 00:00:00');

/********************************** DETERMINE REGION OF USER */

window.alreadyHasConsentCookie = () => {
    const consent = localStorage?.keeper_cookie_consent;
    const validValues = [true, false, 'true', 'false'];
    return validValues.includes(consent);
};

window.regionIsUS = () => {
    if (localStorage) {
        localStorage['keeper_region'] = 'US';
        localStorage['original_keeper_region'] = 'US';

        if (!alreadyHasConsentCookie()) {
            localStorage['keeper_cookie_consent'] = true;
        }
    }

    window.isUserFromUS = true;
    window.isUSofA = true;
};

window.regionIsNonUS = (region, originalRegion) => {
    if (region && localStorage) {
        localStorage['keeper_region'] = region;
        if (originalRegion) {
            localStorage['original_keeper_region'] = originalRegion;
        } else {
            localStorage['original_keeper_region'] = region;
        }

        if (!alreadyHasConsentCookie()) {
            localStorage['keeper_cookie_consent'] = false;
        }
    }

    window.isUserFromUS = false;
    window.isUSofA = false;
};

(() => {
    if (localStorage && localStorage['keeper_region']) {
        if (localStorage['keeper_region'] === 'US') {
            window.regionIsUS();
        } else {
            window.regionIsNonUS(
                localStorage['keeper_region'],
                localStorage['original_keeper_region']
            );
        }
    }

    function handleGetUserCountryData(xCountry, xState) {
        if (
            xCountry &&
            xCountry.trim() === 'us' &&
            (!xState || xState.trim().toLowerCase() !== 'california')
        ) {
            try {
                regionIsUS();
            } catch (e) {
                console.warn(e);
            }
        } else {
            // if the state is california pass an EU country
            const originalCountry = xCountry;
            if (xState && xState.trim().toLowerCase() === 'california') {
                xCountry = 'IE';
            }
            try {
                regionIsNonUS(xCountry.trim(), originalCountry.trim());
            } catch (e) {
                console.warn(e);
            }
        }

        var event = new Event('region_detected');
        document.dispatchEvent(event);
        window.regionDetected = true;
        // just in case region call takes longer than document ready
        if (window.handleConsentUI) {
            window.handleConsentUI();
        }
    }

    var req = new XMLHttpRequest();
    req.open('HEAD', window.keeperPreload.apiEndpoint + '/bi_api/v1/getUserCountry', true);

    req.timeout = 1000; // time in milliseconds

    req.ontimeout = function (e) {
        handleGetUserCountryData('us', 'california');
    };

    req.onload = e => {
        if (req.readyState === 4) {
            if (req.status === 200) {
                var xCountry = '';
                var xState = '';
                req.getAllResponseHeaders()
                    .toLowerCase()
                    .split('\n')
                    .forEach((row, i) => {
                        if (row.length > 1) {
                            var line = row.split(':', 2);
                            line[0] = line[0].replace(' ', '');
                            line[1] = line[1].replace(' ', '');
                            if (line[0].indexOf('x-country-code') !== -1) {
                                if (
                                    window.localStorage &&
                                    window.localStorage.getItem('qa_eu_tester') === 'true'
                                ) {
                                    line[1] = 'IE';
                                }

                                if (
                                    window.localStorage &&
                                    window.localStorage.getItem('qa_region_tester') === 'true'
                                ) {
                                    const xCountryOverride = window.localStorage.getItem(
                                        'qa_country'
                                    );

                                    if (xCountryOverride) {
                                        line[1] = xCountryOverride;
                                    }
                                }

                                xCountry = line[1];
                            } else if (line[0].indexOf('x-state-code') !== -1) {
                                if (
                                    window.localStorage &&
                                    window.localStorage.getItem('qa_region_tester') === 'true'
                                ) {
                                    const xStateOverride = window.localStorage.getItem('qa_state');

                                    if (xStateOverride) {
                                        line[1] = xStateOverride;
                                    }
                                }

                                xState = line[1];
                            }
                        }
                    });
                handleGetUserCountryData(xCountry, xState);
            } else {
                console.error(req.statusText);
            }
        }
    };

    req.onerror = e => {
        console.error(req.statusText);
    };

    req.send(null);
})();

/********************************** POLYFILLS FOR IE & MOBILE */
try {
    if (!Array.from) {
        Array.from = (function () {
            var toStr = Object.prototype.toString;
            var isCallable = function (fn) {
                return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
            };
            var toInteger = function (value) {
                var number = Number(value);
                if (isNaN(number)) {
                    return 0;
                }
                if (number === 0 || !isFinite(number)) {
                    return number;
                }
                return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
            };
            var maxSafeInteger = Math.pow(2, 53) - 1;
            var toLength = function (value) {
                var len = toInteger(value);
                return Math.min(Math.max(len, 0), maxSafeInteger);
            };

            // The length property of the from method is 1.
            return function from(arrayLike /*, mapFn, thisArg */) {
                // 1. Let C be the this value.
                var C = this;

                // 2. Let items be ToObject(arrayLike).
                var items = Object(arrayLike);

                // 3. ReturnIfAbrupt(items).
                if (arrayLike == null) {
                    throw new TypeError(
                        'Array.from requires an array-like object - not null or undefined'
                    );
                }

                // 4. If mapfn is undefined, then let mapping be false.
                var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
                var T;
                if (typeof mapFn !== 'undefined') {
                    // 5. else
                    // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                    if (!isCallable(mapFn)) {
                        throw new TypeError(
                            'Array.from: when provided, the second argument must be a function'
                        );
                    }

                    // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                    if (arguments.length > 2) {
                        T = arguments[2];
                    }
                }

                // 10. Let lenValue be Get(items, "length").
                // 11. Let len be ToLength(lenValue).
                var len = toLength(items.length);

                // 13. If IsConstructor(C) is true, then
                // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
                // 14. a. Else, Let A be ArrayCreate(len).
                var A = isCallable(C) ? Object(new C(len)) : new Array(len);

                // 16. Let k be 0.
                var k = 0;
                // 17. Repeat, while k < len… (also steps a - h)
                var kValue;
                while (k < len) {
                    kValue = items[k];
                    if (mapFn) {
                        A[k] =
                            typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                    } else {
                        A[k] = kValue;
                    }
                    k += 1;
                }
                // 18. Let putStatus be Put(A, "length", len, true).
                A.length = len;
                // 20. Return A.
                return A;
            };
        })();
    }
} catch (e) {}

try {
    if (!String.prototype.includes) {
        Object.defineProperty(String.prototype, 'includes', {
            value: function (search, start) {
                if (typeof start !== 'number') {
                    start = 0;
                }

                if (start + search.length > this.length) {
                    return false;
                } else {
                    return this.indexOf(search, start) !== -1;
                }
            },
        });
    }

    // https://tc39.github.io/ecma262/#sec-array.prototype.includes
    if (!Array.prototype.includes) {
        Object.defineProperty(Array.prototype, 'includes', {
            value: function (searchElement, fromIndex) {
                if (this == null) {
                    throw new TypeError('"this" is null or not defined');
                }

                // 1. Let O be ? ToObject(this value).
                var o = Object(this);

                // 2. Let len be ? ToLength(? Get(O, "length")).
                var len = o.length >>> 0;

                // 3. If len is 0, return false.
                if (len === 0) {
                    return false;
                }

                // 4. Let n be ? ToInteger(fromIndex).
                //    (If fromIndex is undefined, this step produces the value 0.)
                var n = fromIndex | 0;

                // 5. If n ≥ 0, then
                //  a. Let k be n.
                // 6. Else n < 0,
                //  a. Let k be len + n.
                //  b. If k < 0, let k be 0.
                var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

                function sameValueZero(x, y) {
                    return (
                        x === y ||
                        (typeof x === 'number' && typeof y === 'number' && isNaN(x) && isNaN(y))
                    );
                }

                // 7. Repeat, while k < len
                while (k < len) {
                    // a. Let elementK be the result of ? Get(O, ! ToString(k)).
                    // b. If SameValueZero(searchElement, elementK) is true, return true.
                    if (sameValueZero(o[k], searchElement)) {
                        return true;
                    }
                    // c. Increase k by 1.
                    k++;
                }

                // 8. Return false
                return false;
            },
        });
    }

    if (window.NodeList && !NodeList.prototype.forEach) {
        NodeList.prototype.forEach = Array.prototype.forEach;
    }

    if (!Object.assign) {
        Object.defineProperty(Object, 'assign', {
            enumerable: false,
            configurable: true,
            writable: true,
            value: function (target) {
                'use strict';
                if (target === undefined || target === null) {
                    throw new TypeError('Cannot convert first argument to object');
                }

                var to = Object(target);
                for (var i = 1; i < arguments.length; i++) {
                    var nextSource = arguments[i];
                    if (nextSource === undefined || nextSource === null) {
                        continue;
                    }
                    nextSource = Object(nextSource);

                    var keysArray = Object.keys(Object(nextSource));
                    for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex++) {
                        var nextKey = keysArray[nextIndex];
                        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                        if (desc !== undefined && desc.enumerable) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
                return to;
            },
        });
    }

    try {
        (function () {
            if (typeof window.CustomEvent === 'function') return false;

            function CustomEvent(event, params) {
                params = params || {
                    bubbles: false,
                    cancelable: false,
                    detail: undefined,
                };
                var evt = document.createEvent('CustomEvent');
                evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
                return evt;
            }

            CustomEvent.prototype = window.Event.prototype;

            window.CustomEvent = CustomEvent;
            window.Event = CustomEvent;
        })();
    } catch (e) {
        console.warn('POLYFILL FAILED FOR CUSTOMEVENT');
    }

    Math.trunc =
        Math.trunc ||
        function (x) {
            if (isNaN(x)) {
                return NaN;
            }
            if (x > 0) {
                return Math.floor(x);
            }
            return Math.ceil(x);
        };

    (function (global) {
        /**
         * Polyfill URLSearchParams
         *
         * Inspired from : https://github.com/WebReflection/url-search-params/blob/master/src/url-search-params.js
         */

        var checkIfIteratorIsSupported = function () {
            try {
                return !!Symbol.iterator;
            } catch (error) {
                return false;
            }
        };

        var iteratorSupported = checkIfIteratorIsSupported();

        var createIterator = function (items) {
            var iterator = {
                next: function () {
                    var value = items.shift();
                    return {
                        done: value === void 0,
                        value: value,
                    };
                },
            };

            if (iteratorSupported) {
                iterator[Symbol.iterator] = function () {
                    return iterator;
                };
            }

            return iterator;
        };

        /**
         * Search param name and values should be encoded according to https://url.spec.whatwg.org/#urlencoded-serializing
         * encodeURIComponent() produces the same result except encoding spaces as `%20` instead of `+`.
         */
        var serializeParam = function (value) {
            return encodeURIComponent(value).replace(/%20/g, '+');
        };

        var deserializeParam = function (value) {
            return decodeURIComponent(String(value).replace(/\+/g, ' '));
        };

        var polyfillURLSearchParams = function () {
            var URLSearchParams = function (searchString) {
                Object.defineProperty(this, '_entries', {
                    writable: true,
                    value: {},
                });
                var typeofSearchString = typeof searchString;

                if (typeofSearchString === 'undefined') {
                    // do nothing
                } else if (typeofSearchString === 'string') {
                    if (searchString !== '') {
                        this._fromString(searchString);
                    }
                } else if (searchString instanceof URLSearchParams) {
                    var _this = this;
                    searchString.forEach(function (value, name) {
                        _this.append(name, value);
                    });
                } else if (searchString !== null && typeofSearchString === 'object') {
                    if (Object.prototype.toString.call(searchString) === '[object Array]') {
                        for (var i = 0; i < searchString.length; i++) {
                            var entry = searchString[i];
                            if (
                                Object.prototype.toString.call(entry) === '[object Array]' ||
                                entry.length !== 2
                            ) {
                                this.append(entry[0], entry[1]);
                            } else {
                                throw new TypeError(
                                    'Expected [string, any] as entry at index ' +
                                        i +
                                        " of URLSearchParams's input"
                                );
                            }
                        }
                    } else {
                        for (var key in searchString) {
                            if (searchString.hasOwnProperty(key)) {
                                this.append(key, searchString[key]);
                            }
                        }
                    }
                } else {
                    throw new TypeError("Unsupported input's type for URLSearchParams");
                }
            };

            var proto = URLSearchParams.prototype;

            proto.append = function (name, value) {
                if (name in this._entries) {
                    this._entries[name].push(String(value));
                } else {
                    this._entries[name] = [String(value)];
                }
            };

            proto.delete = function (name) {
                delete this._entries[name];
            };

            proto.get = function (name) {
                return name in this._entries ? this._entries[name][0] : null;
            };

            proto.getAll = function (name) {
                return name in this._entries ? this._entries[name].slice(0) : [];
            };

            proto.has = function (name) {
                return name in this._entries;
            };

            proto.set = function (name, value) {
                this._entries[name] = [String(value)];
            };

            proto.forEach = function (callback, thisArg) {
                var entries;
                for (var name in this._entries) {
                    if (this._entries.hasOwnProperty(name)) {
                        entries = this._entries[name];
                        for (var i = 0; i < entries.length; i++) {
                            callback.call(thisArg, entries[i], name, this);
                        }
                    }
                }
            };

            proto.keys = function () {
                var items = [];
                this.forEach(function (value, name) {
                    items.push(name);
                });
                return createIterator(items);
            };

            proto.values = function () {
                var items = [];
                this.forEach(function (value) {
                    items.push(value);
                });
                return createIterator(items);
            };

            proto.entries = function () {
                var items = [];
                this.forEach(function (value, name) {
                    items.push([name, value]);
                });
                return createIterator(items);
            };

            if (iteratorSupported) {
                proto[Symbol.iterator] = proto.entries;
            }

            proto.toString = function () {
                var searchArray = [];
                this.forEach(function (value, name) {
                    searchArray.push(serializeParam(name) + '=' + serializeParam(value));
                });
                return searchArray.join('&');
            };

            global.URLSearchParams = URLSearchParams;
        };

        var checkIfURLSearchParamsSupported = function () {
            try {
                var URLSearchParams = global.URLSearchParams;

                return (
                    new URLSearchParams('?a=1').toString() === 'a=1' &&
                    typeof URLSearchParams.prototype.set === 'function'
                );
            } catch (e) {
                return false;
            }
        };

        if (!checkIfURLSearchParamsSupported()) {
            polyfillURLSearchParams();
        }

        var proto = global.URLSearchParams.prototype;

        if (typeof proto.sort !== 'function') {
            proto.sort = function () {
                var _this = this;
                var items = [];
                this.forEach(function (value, name) {
                    items.push([name, value]);
                    if (!_this._entries) {
                        _this.delete(name);
                    }
                });
                items.sort(function (a, b) {
                    if (a[0] < b[0]) {
                        return -1;
                    } else if (a[0] > b[0]) {
                        return +1;
                    } else {
                        return 0;
                    }
                });
                if (_this._entries) {
                    // force reset because IE keeps keys index
                    _this._entries = {};
                }
                for (var i = 0; i < items.length; i++) {
                    this.append(items[i][0], items[i][1]);
                }
            };
        }

        if (typeof proto._fromString !== 'function') {
            Object.defineProperty(proto, '_fromString', {
                enumerable: false,
                configurable: false,
                writable: false,
                value: function (searchString) {
                    if (this._entries) {
                        this._entries = {};
                    } else {
                        var keys = [];
                        this.forEach(function (value, name) {
                            keys.push(name);
                        });
                        for (var i = 0; i < keys.length; i++) {
                            this.delete(keys[i]);
                        }
                    }

                    searchString = searchString.replace(/^\?/, '');
                    var attributes = searchString.split('&');
                    var attribute;
                    for (var i = 0; i < attributes.length; i++) {
                        attribute = attributes[i].split('=');
                        this.append(
                            deserializeParam(attribute[0]),
                            attribute.length > 1 ? deserializeParam(attribute[1]) : ''
                        );
                    }
                },
            });
        }

        // HTMLAnchorElement
    })(
        typeof global !== 'undefined'
            ? global
            : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
            ? self
            : this
    );

    (function (global) {
        /**
         * Polyfill URL
         *
         * Inspired from : https://github.com/arv/DOM-URL-Polyfill/blob/master/src/url.js
         */

        var checkIfURLIsSupported = function () {
            try {
                var u = new global.URL('b', 'http://a');
                u.pathname = 'c%20d';
                return u.href === 'http://a/c%20d' && u.searchParams;
            } catch (e) {
                return false;
            }
        };

        var polyfillURL = function () {
            var _URL = global.URL;

            var URL = function (url, base) {
                if (typeof url !== 'string') url = String(url);

                // Only create another document if the base is different from current location.
                var doc = document,
                    baseElement;
                if (base && (global.location === void 0 || base !== global.location.href)) {
                    doc = document.implementation.createHTMLDocument('');
                    baseElement = doc.createElement('base');
                    baseElement.href = base;
                    doc.head.appendChild(baseElement);
                    try {
                        if (baseElement.href.indexOf(base) !== 0) throw new Error(baseElement.href);
                    } catch (err) {
                        throw new Error('URL unable to set base ' + base + ' due to ' + err);
                    }
                }

                var anchorElement = doc.createElement('a');
                anchorElement.href = url;
                if (baseElement) {
                    doc.body.appendChild(anchorElement);
                    anchorElement.href = anchorElement.href; // force href to refresh
                }

                if (anchorElement.protocol === ':' || !/:/.test(anchorElement.href)) {
                    throw new TypeError('Invalid URL');
                }

                Object.defineProperty(this, '_anchorElement', {
                    value: anchorElement,
                });

                // create a linked searchParams which reflect its changes on URL
                var searchParams = new global.URLSearchParams(this.search);
                var enableSearchUpdate = true;
                var enableSearchParamsUpdate = true;
                var _this = this;
                ['append', 'delete', 'set'].forEach(function (methodName) {
                    var method = searchParams[methodName];
                    searchParams[methodName] = function () {
                        method.apply(searchParams, arguments);
                        if (enableSearchUpdate) {
                            enableSearchParamsUpdate = false;
                            _this.search = searchParams.toString();
                            enableSearchParamsUpdate = true;
                        }
                    };
                });

                Object.defineProperty(this, 'searchParams', {
                    value: searchParams,
                    enumerable: true,
                });

                var search = void 0;
                Object.defineProperty(this, '_updateSearchParams', {
                    enumerable: false,
                    configurable: false,
                    writable: false,
                    value: function () {
                        if (this.search !== search) {
                            search = this.search;
                            if (enableSearchParamsUpdate) {
                                enableSearchUpdate = false;
                                this.searchParams._fromString(this.search);
                                enableSearchUpdate = true;
                            }
                        }
                    },
                });
            };

            var proto = URL.prototype;

            var linkURLWithAnchorAttribute = function (attributeName) {
                Object.defineProperty(proto, attributeName, {
                    get: function () {
                        return this._anchorElement[attributeName];
                    },
                    set: function (value) {
                        this._anchorElement[attributeName] = value;
                    },
                    enumerable: true,
                });
            };

            ['hash', 'host', 'hostname', 'port', 'protocol'].forEach(function (attributeName) {
                linkURLWithAnchorAttribute(attributeName);
            });

            Object.defineProperty(proto, 'search', {
                get: function () {
                    return this._anchorElement['search'];
                },
                set: function (value) {
                    this._anchorElement['search'] = value;
                    this._updateSearchParams();
                },
                enumerable: true,
            });

            Object.defineProperties(proto, {
                toString: {
                    get: function () {
                        var _this = this;
                        return function () {
                            return _this.href;
                        };
                    },
                },

                href: {
                    get: function () {
                        return this._anchorElement.href.replace(/\?$/, '');
                    },
                    set: function (value) {
                        this._anchorElement.href = value;
                        this._updateSearchParams();
                    },
                    enumerable: true,
                },

                pathname: {
                    get: function () {
                        return this._anchorElement.pathname.replace(/(^\/?)/, '/');
                    },
                    set: function (value) {
                        this._anchorElement.pathname = value;
                    },
                    enumerable: true,
                },

                origin: {
                    get: function () {
                        // get expected port from protocol
                        var expectedPort = {
                            'http:': 80,
                            'https:': 443,
                            'ftp:': 21,
                        }[this._anchorElement.protocol];
                        // add port to origin if, expected port is different than actual port
                        // and it is not empty f.e http://foo:8080
                        // 8080 != 80 && 8080 != ''
                        var addPortToOrigin =
                            this._anchorElement.port != expectedPort &&
                            this._anchorElement.port !== '';

                        return (
                            this._anchorElement.protocol +
                            '//' +
                            this._anchorElement.hostname +
                            (addPortToOrigin ? ':' + this._anchorElement.port : '')
                        );
                    },
                    enumerable: true,
                },

                password: {
                    // TODO
                    get: function () {
                        return '';
                    },
                    set: function (value) {},
                    enumerable: true,
                },

                username: {
                    // TODO
                    get: function () {
                        return '';
                    },
                    set: function (value) {},
                    enumerable: true,
                },
            });

            URL.createObjectURL = function (blob) {
                return _URL.createObjectURL.apply(_URL, arguments);
            };

            URL.revokeObjectURL = function (url) {
                return _URL.revokeObjectURL.apply(_URL, arguments);
            };

            global.URL = URL;
        };

        if (!checkIfURLIsSupported()) {
            polyfillURL();
        }

        if (global.location !== void 0 && !('origin' in global.location)) {
            var getOrigin = function () {
                return (
                    global.location.protocol +
                    '//' +
                    global.location.hostname +
                    (global.location.port ? ':' + global.location.port : '')
                );
            };

            try {
                Object.defineProperty(global.location, 'origin', {
                    get: getOrigin,
                    enumerable: true,
                });
            } catch (e) {
                setInterval(function () {
                    global.location.origin = getOrigin();
                }, 100);
            }
        }
    })(
        typeof global !== 'undefined'
            ? global
            : typeof window !== 'undefined'
            ? window
            : typeof self !== 'undefined'
            ? self
            : this
    );
} catch (e) {
    console.warn(e);
}

/********************************** BROWSER LANGUAGE DETECTION */

var languageToLocale = {
    af: 'af-ZA',
    ar: 'ar',
    bg: 'bg-BG',
    ca: 'ca-AD',
    cs: 'cs-CZ',
    cy: 'cy-GB',
    da: 'da-DK',
    de: 'de-DE',
    el: 'el-GR',
    en: 'en-US',
    es: 'es-ES',
    et: 'et-EE',
    eu: 'eu',
    fa: 'fa-IR',
    fi: 'fi-FI',
    fr: 'fr-FR',
    he: 'he-IL',
    hr: 'hr-HR',
    hu: 'hu-HU',
    id: 'id-ID',
    is: 'is-IS',
    it: 'it-IT',
    ja: 'ja-JP',
    km: 'km-KH',
    ko: 'ko-KR',
    lt: 'lt-LT',
    lv: 'lv-LV',
    mn: 'mn-MN',
    nb: 'nb-NO',
    nl: 'nl-NL',
    nn: 'nn-NO',
    pl: 'pl-PL',
    pt: 'pt-PT',
    ro: 'ro-RO',
    ru: 'ru-RU',
    sk: 'sk-SK',
    sl: 'sl-SI',
    sr: 'sr-RS',
    sv: 'sv-SE',
    th: 'th-TH',
    tr: 'tr-TR',
    uk: 'uk-UA',
    vi: 'vi-VN',
    zh: 'zh-CN',
};

var supportedLocales = [
    'qa_QA',
    'ar_AE',
    'de_DE',
    'en_US',
    'en_GB',
    'es_ES',
    'fr_FR',
    'it_IT',
    'ja_JP',
    'nl_NL',
    'pl_PL',
    'pt_BR',
    'ru_RU',
    'zh_CN',
];

window.keeperPreload.hasLocaleCookie = function () {
    // checks for locale cookie
    return localStorage['keeper_locale'] !== undefined;
};

window.keeperPreload.getLocaleCookie = function () {
    // returns locale cookie
    return localStorage['keeper_locale'];
};

window.keeperPreload.setLocaleCookie = function (locale) {
    // sets locale cookie
    var language = locale.substr(0, 2);

    if (localStorage['keeper_locale'] !== locale) {
        sessionStorage.removeItem('currency_code');
        sessionStorage.removeItem('product_pricing_data');
    }
    localStorage['keeper_lang'] = language;
    localStorage['keeper_locale'] = locale;
};

window.keeperPreload.redirectLocale = function (locale) {
    // redirects to desired locale
    if (locale === 'en_US') return;
    window.location.assign(
        '/' + locale + window.location.pathname + window.location.search + window.location.hash
    );
};

window.keeperPreload.hasLocaleInURL = function () {
    // returns whether or not locale is in URL
    return window.location.pathname.substring(3, 4).indexOf('_') != -1;
};

window.keeperPreload.getLocaleFromParam = function () {
    // returns whether or not locale is in URL
    let params = new URLSearchParams(document.location.search);
    const region = params.get('website_locale');
    return region;
};

window.keeperPreload.hasLocaleInParam = function () {
    // returns whether or not locale is in URL
    let params = new URLSearchParams(document.location.search);
    const region = params.get('website_locale');
    return !!region;
};

window.keeperPreload.getLanguageInURL = function () {
    if (!window.keeperPreload.hasLocaleInURL()) return;
    return window.location.pathname.substring(1, 3);
};

window.keeperPreload.getLocaleInURL = function () {
    if (!window.keeperPreload.hasLocaleInURL()) return;
    return window.location.pathname.substr(1, 5);
};

window.keeperPreload.hasCookieConsent = function () {
    return localStorage['keeper_cookie_consent'];
};

window.keeperPreload.getBrowserLocale = function () {
    var locale;

    if (navigator.language.indexOf('-') !== -1) locale = navigator.language.split('-');
    else if (navigator.language.indexOf('_') !== -1) locale = navigator.language.split('_');
    else locale = languageToLocale[navigator.language].replace(',', '-').split('-');

    locale[0] = locale[0].toLowerCase();
    locale[1] = locale[1].toUpperCase();
    locale = locale.join('_');

    if (!supportedLocales.includes(locale)) {
        return 'en_US';
    }

    return locale;
};

//validating the locale in the cookie and in the url before redirecting
if (window.keeperPreload.hasLocaleInURL()) {
    var urlLocale = window.keeperPreload.getLocaleInURL();
    if (!supportedLocales.includes(urlLocale)) {
        var pathNameWithNewLocale = window.location.pathname.replace('/' + urlLocale, '');
        pathNameWithNewLocale = '/en_US' + pathNameWithNewLocale;
        window.keeperPreload.setLocaleCookie('en_US');
        location.href = pathNameWithNewLocale + window.location.search + window.location.hash;
    }
}

if (window.keeperPreload.hasLocaleInURL()) {
    // no redirect needed | store locale in cookie
    window.keeperPreload.setLocaleCookie(window.keeperPreload.getLocaleInURL());
} else if (window.keeperPreload.hasLocaleInParam()) {
    // no redirect needed | store locale in cookie
    window.keeperPreload.setLocaleCookie(window.keeperPreload.getLocaleFromParam());
} else if (window.keeperPreload.hasLocaleCookie()) {
    // redirect to locale in cookie
    if (
        window.localStorage.getItem('original_keeper_region') === 'US' &&
        window.keeperPreload.getLocaleCookie() === 'en_GB' &&
        window.keeperPreload.getBrowserLocale() === 'en_US'
    ) {
        // english locale mismatch

        if (window.localStorage.getItem('keeper_selected_lang') === 'en_GB') {
            // set locale to en_GB if explicitly selected
            window.keeperPreload.redirectLocale('en_GB');
        } else {
            window.keeperPreload.redirectLocale('en_US');
        }
    } else if (
        window.keeperPreload.getLocaleCookie() &&
        supportedLocales.includes(window.keeperPreload.getLocaleCookie())
    ) {
        window.keeperPreload.redirectLocale(window.keeperPreload.getLocaleCookie());
    }
} else if (!window.keeperPreload.hasLocaleInURL() && !window.keeperPreload.hasLocaleCookie()) {
    // redirect to browser locale
    if (supportedLocales.includes(window.keeperPreload.getBrowserLocale())) {
        window.keeperPreload.setLocaleCookie(window.keeperPreload.getBrowserLocale());
        window.keeperPreload.redirectLocale(window.keeperPreload.getBrowserLocale());
    }
}

window.keeperPreload.rakutenConversion = function (rm_trans) {
    if (!window.DataLayer) {
        window.DataLayer = {Sale: {Basket: rm_trans}};
    } else {
        DataLayer.Sale = DataLayer.Sale || {Basket: rm_trans};
        DataLayer.Sale.Basket = DataLayer.Sale.Basket || rm_trans;
    }
    DataLayer.Sale.Basket.Ready = true;
    function __readRMCookie(e) {
        for (var a = e + '=', t = document.cookie.split(';'), r = 0; r < t.length; r++) {
            for (var i = t[r]; ' ' == i.charAt(0); ) i = i.substring(1, i.length);
            if (0 == i.indexOf(a)) return i.substring(a.length, i.length);
        }
        return '';
    }
    function __readRMCookiev2(e, a) {
        for (var t = __readRMCookie((a = a || 'rmStore')); t !== decodeURIComponent(t); )
            t = decodeURIComponent(t);
        for (var r = t.split('|'), i = 0; i < r.length; i++) {
            var n = r[i].split(':')[0],
                o = r[i].split(':')[1];
            if (n === e) return o;
        }
        return '';
    }
    function __readParam(e, a, t, r) {
        var i = e || '',
            n = a || '',
            o = t || '',
            s = r || {},
            d = __readRMCookiev2(i),
            u = s[n],
            m = (d = s.ignoreCookie || !1 ? 0 : d) || u || o;
        return (m = ('string' != typeof m || 'false' !== m.toLowerCase()) && m);
    }
    function sRAN() {
        var e = DataLayer && DataLayer.Sale && DataLayer.Sale.Basket ? DataLayer.Sale.Basket : {},
            a = e.affiliateConfig || {},
            t = __readParam('atm', 'tagType', 'pixel', a),
            r = __readParam('adr', 'discountType', 'order', a),
            i = __readParam('acs', 'includeStatus', 'false', a),
            n = __readParam('arto', 'removeOrderTax', 'false', a),
            o = __readParam('artp', 'removeTaxFromProducts', 'false', a),
            s = __readParam('artd', 'removeTaxFromDiscount', 'false', a),
            d = __readParam('atr', 'taxRate', 0, a);
        d = Number(d);
        var u =
                __readParam('ald', 'land', !1, {}) ||
                (a.land && !0 === a.land ? __readRMCookie('ranLandDateTime') : a.land) ||
                !1,
            m =
                __readParam('atrv', 'tr', !1, {}) ||
                (a.tr && !0 === a.tr ? __readRMCookie('ranSiteID') : a.tr) ||
                !1,
            l = !1,
            c = __readParam('amid', 'ranMID', '', a) || e.ranMID;
        if (!c) return !1;
        if (!(void 0 === a.allowCommission || 'false' !== a.allowCommission)) return !1;
        var p = e.orderid || 'OrderNumberNotAvailable',
            f = '',
            y = '',
            _ = '',
            v = '',
            N = e.currency || '',
            h = e.taxAmount ? Math.abs(Math.round(100 * Number(e.taxAmount))) : 0,
            g = e.discountAmount ? Math.abs(Math.round(100 * Number(e.discountAmount))) : 0;
        if (s && d)
            var b = (100 + Number(d)) / 100,
                g = Math.round(g / b);
        var C = 'pixel' === t ? 'ep' : 'mop' === t ? 'eventnvppixel' : 'ep',
            S = e.customerStatus || '',
            D = document.location.protocol + '//track.linksynergy.com/' + C + '?',
            w = '';
        null != S &&
            '' != S &&
            ((i && 'EXISTING' == S.toUpperCase()) || (i && 'RETURNING' == S.toUpperCase())) &&
            (w = 'R_');
        for (var P = [], x = 0, T = 0; T < (e.lineitems ? e.lineitems.length : 0); T++) {
            for (
                var L = !1,
                    k = window.JSON ? JSON.parse(JSON.stringify(e.lineitems[T])) : e.lineitems[T],
                    R = 0;
                R < P.length;
                R++
            )
                P[R].SKU === k.SKU &&
                    ((L = !0), (P[R].quantity = Number(P[R].quantity) + Number(k.quantity)));
            L || P.push(k),
                (x += Number(k.quantity) * Number(k.unitPriceLessTax || k.unitPrice) * 100);
        }
        for (T = 0; T < P.length; T++) {
            var k = P[T],
                I = encodeURIComponent(k.SKU),
                M = k.unitPriceLessTax || k.unitPrice,
                A = k.quantity,
                U = encodeURIComponent(k.productName) || '',
                O = Math.round(Number(M) * Number(A) * 100);
            !o ||
                !d ||
                (k.unitPriceLessTax && k.unitPriceLessTax !== k.unitPrice) ||
                (O /= b = (100 + d) / 100),
                'item' === r.toLowerCase() && g && (O -= (g * O) / x),
                (f += w + I + '|'),
                (y += A + '|'),
                (_ += Math.round(O) + '|'),
                (v += w + U + '|');
        }
        (f = f.slice(0, -1)),
            (y = y.slice(0, -1)),
            (_ = _.slice(0, -1)),
            (v = v.slice(0, -1)),
            g && 'order' === r.toLowerCase()
                ? ((f += '|' + w + 'DISCOUNT'),
                  (v += '|' + w + 'DISCOUNT'),
                  (y += '|0'),
                  (_ += '|-' + g))
                : g && 'item' === r.toLowerCase() && (l = !0),
            n &&
                h &&
                ((f += '|' + w + 'ORDERTAX'),
                (y += '|0'),
                (_ += '|-' + h),
                (v += '|' + w + 'ORDERTAX')),
            (D +=
                'mid=' +
                c +
                '&ord=' +
                p +
                '&skulist=' +
                f +
                '&qlist=' +
                y +
                '&amtlist=' +
                _ +
                '&cur=' +
                N +
                '&namelist=' +
                v +
                '&img=1&'),
            u && (D += 'land=' + u + '&'),
            m && (D += 'tr=' + m + '&'),
            l && (D += 'discount=' + g + '&'),
            '&' === D[D.length - 1] && (D = D.slice(0, -1));
        var E,
            B = document.createElement('img');
        B.setAttribute('src', D),
            B.setAttribute('height', '1px'),
            B.setAttribute('width', '1px'),
            (E = document.getElementsByTagName('script')[0]).parentNode.insertBefore(B, E);
    }
    function sDisplay() {
        var e = null,
            a = null,
            t = null,
            r = null,
            i =
                window.DataLayer && window.DataLayer.Sale && window.DataLayer.Sale.Basket
                    ? window.DataLayer.Sale.Basket
                    : {},
            n = i.displayConfig || {},
            o = i.customerStatus || '',
            s = i.discountAmount ? Math.abs(Number(i.discountAmount)) : 0,
            d = __readParam('dmid', 'rdMID', '', n);
        if (!d) return !1;
        var u = __readParam('dtm', 'tagType', 'js', n),
            m =
                'if' === (u = 'js' === u || 'if' === u || 'img' === u ? u : 'js')
                    ? 'iframe'
                    : 'img' === u
                    ? u
                    : 'script',
            l =
                '//' +
                __readParam('ddn', 'domain', 'tags.rd.linksynergy.com', n) +
                '/' +
                u +
                '/' +
                d,
            c = __readParam('dis', 'includeStatus', 'false', n),
            p = '';
        if (
            (null != o &&
                '' != o &&
                ((c && 'EXISTING' == o.toUpperCase()) || (c && 'RETURNING' == o.toUpperCase())) &&
                (p = 'R_'),
            !i.orderid || 'sale' !== i.conversionType.toLowerCase())
        )
            return !1;
        (t = 0), (a = p + i.orderid), (e = ''), (r = 'conv');
        for (var f = 0; f < (i.lineitems ? i.lineitems.length : 0); f++)
            (t +=
                Number(i.lineitems[f].unitPriceLessTax) * Number(i.lineitems[f].quantity) ||
                Number(i.lineitems[f].unitPrice) * Number(i.lineitems[f].quantity)),
                (e += i.lineitems[f].SKU + ',');
        (t = Math.round(100 * (t - s)) / 100),
            (e = e.slice(0, -1)) &&
                (l = l.indexOf('?') > -1 ? l + '&prodID=' + e : l + '/?prodID=' + e),
            a && (l = l.indexOf('?') > -1 ? l + '&orderNumber=' + a : l + '/?orderNumber=' + a),
            t && (l = l.indexOf('?') > -1 ? l + '&price=' + t : l + '/?price=' + t),
            r && (l = l.indexOf('?') > -1 ? l + '&pt=' + r : l + '/?pt=' + r);
        var y = document.createElement(m);
        (y.src = l),
            'script' === m
                ? (y.type = 'text/javascript')
                : 'iframe' === m && y.setAttribute('style', 'display: none;'),
            document.getElementsByTagName('body')[0].appendChild(y);
    }
    function sSearch() {
        var e =
                window.DataLayer && window.DataLayer.Sale && window.DataLayer.Sale.Basket
                    ? window.DataLayer.Sale.Basket
                    : {},
            a = e.searchConfig || {},
            t = __readParam('smid', 'rsMID', '', a);
        if (!t) return !1;
        var r = function () {
                var r = e.discountAmount ? Math.abs(Number(e.discountAmount)) : 0,
                    i = __readParam('sct', 'conversionType', 'conv', a),
                    n = 0,
                    o = '';
                if (!e.orderid) return !1;
                (n = 0), (o = e.orderid);
                for (var s = 0; s < (e.lineitems ? e.lineitems.length : 0); s++)
                    n += Number(e.lineitems[s].unitPrice) * Number(e.lineitems[s].quantity);
                n = Math.round(100 * (n - r)) / 100;
                window.DataLayer.Sale.Basket;
                var d = [];
                (d[0] = 'id=' + t),
                    (d[1] = 'type=' + i),
                    (d[2] = 'val=' + n),
                    (d[3] = 'orderId=' + o),
                    (d[4] = 'promoCode=' + e.discountCode || ''),
                    (d[5] = 'valueCurrency=' + e.currency || 'USD'),
                    (d[6] = 'GCID='),
                    (d[7] = 'kw='),
                    (d[8] = 'product='),
                    k_trackevent(d, '113');
            },
            i = document.location.protocol.indexOf('s') > -1 ? 'https://' : 'http://';
        i += '113.xg4ken.com/media/getpx.php?cid=' + t;
        var n = document.createElement('script');
        (n.type = 'text/javascript'),
            (n.src = i),
            (n.onload = r),
            (n.onreadystatechange = function () {
                ('complete' != this.readyState && 'loaded' != this.readyState) || r();
            }),
            document.getElementsByTagName('head')[0].appendChild(n);
    }
    sRAN(), sDisplay(), sSearch();
};

// Lazy Load Video elements
document.addEventListener('DOMContentLoaded', function () {
    var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy'));

    if ('IntersectionObserver' in window) {
        var lazyVideoObserver = new IntersectionObserver(function (entries, observer) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    for (var source in video.target.children) {
                        var videoSource = video.target.children[source];
                        if (
                            typeof videoSource.tagName === 'string' &&
                            videoSource.tagName === 'SOURCE'
                        ) {
                            videoSource.src = videoSource.dataset.src;
                        }
                    }

                    video.target.load();
                    video.target.classList.remove('lazy');
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }
});

(function () {
    const links = document.querySelectorAll('.preloadStyle');

    var loadStyle = function (link) {
        link.removeEventListener('load', handleLoad, false);
        link.rel = 'stylesheet';
        link.classList.remove('preloadStyle');
        link.classList.add('loaded');
    };

    var handleLoad = function (event) {
        loadStyle(event.currentTarget);
    };

    // Load preloaded stylesheets in <HEAD>
    links.forEach(link => {
        if (link.sheet) {
            loadStyle(link);
        } else {
            link.addEventListener('load', handleLoad, false);
        }
    });

    // Load any remaining stylesheets marked for preload
    document.addEventListener('DOMContentLoaded', function () {
        const links = document.querySelectorAll('.preloadStyle');

        links.forEach(link => {
            loadStyle(link);
        });
    });
})();

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-action="scroll-top"]').forEach(function (e) {
        e.addEventListener('click', function () {
            let focusable = document
                .querySelector('main')
                .querySelectorAll(
                    'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
                );
            window.scrollTo(0, 0);
            focusable[0].focus();
        });
    });
});

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.featureCompChart.mobileCollapsible').forEach(function (table) {
        table.addEventListener('click', function (e) {
            if (!e.target.closest('.featureName')) return;

            var $row = $(e.target).closest('.chartRow');
            var $table = $(e.target).closest('.featureCompChart');

            if ($row.hasClass('open')) {
                $row.removeClass('open');
            } else {
                $table.find('.chartRow').removeClass('open');
                $row.addClass('open');
            }
        });
    });
});

document.addEventListener('DOMContentLoaded', event => {
    // all elements with background images that should be lazy loaded
    const lazyImages = document.querySelectorAll('.lazybg');

    // options for the observer
    const backgroundOptions = {
        threshold: 0,
        rootMargin: '0px 0px 50px 0px',
    };

    // the observer
    const imageObserver = new IntersectionObserver((entries, imageObserver) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                showImageBackground(entry.target);
                imageObserver.unobserve(entry.target);
            }
        });
    }, backgroundOptions);

    // observe each image
    lazyImages.forEach(image => {
        imageObserver.observe(image);
    });

    // show background image
    function showImageBackground(node) {
        node.classList.remove('lazybg');
    }
});
